import React, {useState, useEffect} from 'react';
import dClient, {clientNoLoader} from '../../api/reduxLoaderApi';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


import {
    Button,
    Checkbox,
    Divider,
    FormControlLabel,
    Grid,
    lighten,
    MenuItem,
    TextField,
    FormControl
} from '@mui/material';

import { makeStyles } from "@mui/styles";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

// import {FormFields} from '@shelveda/common/';
import failStatus from "../../utils/failStatus";

// const {LoaderField} = FormFields;

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(4),
        backgroundColor: lighten(theme.palette.background.paper, 0.1),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
    },
    editIcon: {
        color: '#FF8C00',
    },
    deleteIcon: {
        color: 'red',
    },
    viewEx: {
        color: '#0054a7',
    },
    item: {
        padding: '0 8px',
    },
}));

const searchUser = async (search) => {
    const res = await clientNoLoader(
        'get',
        '/admin/users',
        {
            params: {
                search,
            },
        },
        {},
        false,
    );
    if (failStatus(res)) return [];
    return res.data;
    // return setter([{ id: undefined, title: 'همه' }, ...res.data]);
};

// const getCategoriesByCategoryCombo = async (category_id, setter) => {
//   const res = await dClient(
//     'get',
//     '/admin/lessons',
//     {
//       params: {
//         course_id,
//         dropdown: true,
//         per_page: 1000,
//         page: 1,
//       },
//     },
//     {},
//     false,
//   );
//   if (failStatus(res)) return [];
//   return setter([{ id: 'all', title: 'همه' }, ...res.data.data]);
// };

export default function AdvanceSearchUser(props) {
    const {setParams} = props;
    const [categories, setCategories] = useState([]);

    const [formVal, setFormVal] = useState({
        first_name:"",
        last_name:"",
        email:"",
        mobile: ""
    });

    useEffect(() => {
        // getLessonsByCourseCombo(setLessons);
    }, []);

    function handleLessonChange(e) {
        const {name, value} = e.target;

        return setFormVal((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    function submitForm() {
        let currentForm = {...formVal};
        const {category, title} = formVal;
        if (category === 'all' || category === '') {
            currentForm.category = undefined;
        }
        setParams({...currentForm});
    }

    // function onUserFieldChange
    // mapNullToUndefined

    const classes = useStyles();
    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                <h3 className="m-0">جستجوی پیشرفته</h3>
            </AccordionSummary>
            <Divider/>

            <AccordionDetails>
                <Grid
                    style={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        width: "100%",
                        margin: 0
                    }}
                    container
                    spacing={6}
                >
                    <Grid
                        className={classes.item}
                        container
                        justify="center"
                        xs={6}
                    >
                        <FormControl
                            fullWidth
                            spacing={4}
                            // style={{ paddingRight: '1.2rem', paddingBottom: '1.2rem' }}
                        >
                            <TextField
                                label={'نام'}
                                variant="outlined"
                                autoComplete="name"
                                margin="normal"
                                value={formVal.first_name}
                                fullWidth
                                onChange={(item) => {
                                    setFormVal((prev) => ({...prev, first_name: item.target.value}));
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid
                        className={classes.item}
                        container
                        justify="center"
                        xs={6}
                    >
                        <FormControl
                            fullWidth
                            spacing={4}
                            // style={{ paddingRight: '1.2rem', paddingBottom: '1.2rem' }}
                        >
                            <TextField
                                label={'نام خانوادگی'}
                                variant="outlined"
                                autoComplete="name"
                                margin="normal"
                                value={formVal.last_name}
                                fullWidth
                                onChange={(item) => {
                                    setFormVal((prev) => ({...prev, last_name: item.target.value}));
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid
                        className={classes.item}
                        container
                        justify="center"
                        xs={6}
                    >
                        <FormControl
                            fullWidth
                            spacing={4}
                            // style={{ paddingRight: '1.2rem', paddingBottom: '1.2rem' }}
                        >
                            <TextField
                                label={'موبایل'}
                                variant="outlined"
                                autoComplete="name"
                                margin="normal"
                                value={formVal.mobile}
                                fullWidth
                                onChange={(item) => {
                                    setFormVal((prev) => ({...prev, mobile: item.target.value}));
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid
                        className={classes.item}
                        container
                        justify="center"
                        xs={6}
                    >
                        <FormControl
                            fullWidth
                            spacing={4}
                            // style={{ paddingRight: '1.2rem', paddingBottom: '1.2rem' }}
                        >
                            <TextField
                                label={'ایمیل'}
                                variant="outlined"
                                autoComplete="name"
                                margin="normal"
                                value={formVal.email}
                                fullWidth
                                onChange={(item) => {
                                    setFormVal((prev) => ({...prev, email: item.target.value}));
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid
                        className={classes.item}
                        container
                        justify="center"
                        xs={6}
                    ></Grid>
                    <Grid
                        className={classes.item}
                        container
                        justify="center"
                        xs={6}
                    >
                        <Button
                            className={classes.submitBtn}
                            variant="contained"
                            color="primary"
                            onClick={submitForm}
                        >
                            ثبت
                        </Button>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}
